<template>
  <div class="container-fluid d-flex flex-column flex-grow-1 mt-3">
    <ListingComponent class="bg-white"
                      ref="telegramMemberList"
                      :showChatIdFilter="true"
                      :requestProvider="requestProvider"
                      :columnConfig="columnConfig">
    </ListingComponent>
  </div>
</template>

<script>
import ListingComponent from '@/components/listing/ListingComponent'
import moment from "moment";
export default {
  name: 'TelegramMemberListPage',
  data () {
    return {
      // eslint-disable-next-line no-sparse-arrays
      columnConfig: [
        {
          columnCode: 'action',
          columnName: 'Action',
          value: (item) => {
            let blockedItem
            if (item.blocked) {
              blockedItem = <b-dropdown-item onClick={() => this.blockMember(item.id, false)}>Unblock</b-dropdown-item>
            } else {
              blockedItem = <b-dropdown-item onClick={() => this.blockMember(item.id, true)}>Block</b-dropdown-item>
            }
            return (
              <b-dropdown variant="link" class="listing-action">
                {blockedItem}
              </b-dropdown>
            )
          }
        },
        {
          columnCode: 'chatId',
          columnName: 'Chat Id',
          align: 'left',
          value: item => {
            return item.chatId
          }
        },
        {
          columnCode: 'firstName',
          columnName: 'First Name',
          align: 'left',
          value: item => {
            return item.firstName
          }
        },
        {
          columnCode: 'lastName',
          columnName: 'Last Name',
          align: 'left',
          value: item => {
            return item.lastName
          }
        },
        {
          columnCode: 'username',
          columnName: 'Username',
          align: 'left',
          value: item => {
            return item.username
          }
        },
        {
          columnCode: 'walletId',
          columnName: 'Wallet',
          align: 'left',
          value: item => {
            return item.walletId
          }
        },
        {
          columnCode: 'changedDate',
          columnName: 'Changed Date',
          align: 'left',
          value: item => {
            return item.walletDate ? moment(item.walletDate).format('YYYY-MM-DD HH:mm') : ''
          }
        },
        {
          columnCode: 'blocked',
          columnName: 'Blocked',
          align: 'left',
          value: item => {
            return item.blocked ? 'Yes' : '-'
          }
        }
      ]
    }
  },
  methods: {
    requestProvider (payload) {
      return this.axios.get('telegram-member/list', payload)
    },
    blockMember (id, isBlock) {
      if (!id) {
        return
      }
      this.$loading.show()
      this.axios.put('telegram-member/block', {id: id, block: isBlock})
        .then((result) => {
          this.$refs.telegramMemberList.doRequest()
          this.$loading.hide()
          if (result && result.data && result.data.status === 200) {
            if (isBlock) {
              this.$toastr.success('Member successfully blocked')
            } else {
              this.$toastr.success('Member successfully unblocked')
            }
          }
        })
    }
  },
  components: {
    ListingComponent
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/telegrammember/TelegramMemberListPage.vue